import * as models from "./api/models";

export default function isApplicationKey(value: string): value is models.AppKeys {
    return !!Object.values(models.AppKeys).find((key) => key === value);
}
